import type { ChangeEvent, ComponentType } from 'react';
import { useCallback, useContext, useState } from 'react';
import { X } from 'react-feather';
import styles from './style/KeywordSearch.module.css';
import { useDebounceCallback } from '@trinity/chat-components/hooks/useDebounce';
import { ProjectClipsFiltersContext, SetProjectClipsFiltersContext } from '../../contexts/project-clips';
import { Search } from '../icons/Search';

type Props = {
  SearchIconComponent?: ComponentType<{ className?: string; size?: number }>;
};

export const KeywordSearch = ({ SearchIconComponent }: Props) => {
  const Icon = SearchIconComponent ?? Search;
  const filters = useContext(ProjectClipsFiltersContext);
  const setFilters = useContext(SetProjectClipsFiltersContext);
  const [value, setValue] = useState(filters.keyword);

  const updateFilters = useCallback(
    (keyword: string) => {
      setFilters({
        keyword,
        speakerRole: keyword ? filters.speakerRole : 'all',
      });
    },
    [filters.speakerRole, setFilters]
  );

  const clearFilter = useCallback(() => {
    setValue('');
    setFilters({
      keyword: '',
    });
  }, [setFilters]);

  const debouncedUpdateFilters = useDebounceCallback(updateFilters, 300);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      debouncedUpdateFilters(e.target.value);
    },
    [debouncedUpdateFilters]
  );

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.left}>
          <Icon className={styles.icon} size={22} />
          <input
            className={styles.input}
            autoComplete="off"
            name="highlights-search"
            placeholder="Search transcript text"
            type="text"
            onChange={handleChange}
            value={value}
          />
        </div>
        {value && <X className={styles.x} onClick={clearFilter} size={22} />}
      </div>
    </div>
  );
};
